import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Centralized image URL helper with cache-busting
// This ensures all images use absolute URLs and bypass browser cache
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function getImageUrl(url) {
  if (!url) return 'https://via.placeholder.com/400?text=VALMÉRA';
  
  // Already absolute URL (external images like Google profile pics)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Relative URL starting with /api/ - prepend backend URL
  if (url.startsWith('/api/')) {
    // Persistent object-storage URLs are immutable (UUID-keyed) - no cache buster needed
    if (url.startsWith('/api/files/')) {
      return `${BACKEND_URL}${url}`;
    }
    const cacheBuster = `?v=${Date.now()}`;
    return `${BACKEND_URL}${url}${cacheBuster}`;
  }
  
  // Relative URL without /api/ prefix - add it
  if (url.startsWith('/')) {
    const cacheBuster = `?v=${Date.now()}`;
    return `${BACKEND_URL}/api${url}${cacheBuster}`;
  }
  
  // Plain filename - assume it's in uploads
  const cacheBuster = `?v=${Date.now()}`;
  return `${BACKEND_URL}/api/uploads/${url}${cacheBuster}`;
}
